(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    logger;

  const renderEpaperWidget = (epaperWidget) => {
    if (!epaperWidget) {
      logger.log('_init: No widget.');
      return;
    }

    let vn = epaperWidget.getAttribute('data-vn') || false;
    let neueSonntag = epaperWidget.getAttribute('data-neue-sonntag') || false;
    let widgetId = epaperWidget.getAttribute('data-widget-id') || false;
    let template = epaperWidget.getAttribute("data-template") || '';

    if (!widgetId) {
      logger.log('_init: No widget id.');
      return;
    }

    const epaper = Vue.createApp({
      components: {
        EpaperWidget: window["@russmedia-frontend/np-widgets"].EpaperWidget,
      },
      setup() {
        return {
          vn,
          neueSonntag,
          template,
        };
      },
      template: `<EpaperWidget :vn="vn" :neueSonntag="neueSonntag" :template="template"></EpaperWidget>`,
    }).mount("#vodl-epaper-" + widgetId);
  };

  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[epaper] ");
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    const epaperWidgets = document.querySelectorAll('.vodl-epaper-widget');

    if (epaperWidgets && epaperWidgets.length > 0) {
      epaperWidgets.forEach(epaperWidget => {
        renderEpaperWidget(epaperWidget);
      });
    }
  };

  init();
})(window, document);
